 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPS9781454940760_EPUB_CVI_R1 from '@/components/OEBPS/9781454940760_epub_cvi_r1'
 import LOVE_1 from '@/components/love_1'
 import OEBPS9781454940760_EPUB_TP_R1 from '@/components/OEBPS/9781454940760_epub_tp_r1'
 import OEBPS9781454940760_EPUB_COP_R1 from '@/components/OEBPS/9781454940760_epub_cop_r1'
 import OEBPS9781454940760_EPUB_TOC_R1 from '@/components/OEBPS/9781454940760_epub_toc_r1'
 import OEBPS9781454940760_EPUB_INT_R1 from '@/components/OEBPS/9781454940760_epub_int_r1'
 import OEBPS9781454940760_EPUB_CH1_R1 from '@/components/OEBPS/9781454940760_epub_ch1_r1'
 import OEBPS9781454940760_EPUB_CH2_R1 from '@/components/OEBPS/9781454940760_epub_ch2_r1'
 import OEBPS9781454940760_EPUB_CH3_R1 from '@/components/OEBPS/9781454940760_epub_ch3_r1'
 import OEBPS9781454940760_EPUB_CH4_R1 from '@/components/OEBPS/9781454940760_epub_ch4_r1'
 import OEBPS9781454940760_EPUB_CH5_R1 from '@/components/OEBPS/9781454940760_epub_ch5_r1'
 import OEBPS9781454940760_EPUB_CH6_R1 from '@/components/OEBPS/9781454940760_epub_ch6_r1'
 import LOVE_2 from '@/components/love_2'
 import OEBPS9781454940760_EPUB_APA_R1 from '@/components/OEBPS/9781454940760_epub_apa_r1'
 import OEBPS9781454940760_EPUB_APB_R1 from '@/components/OEBPS/9781454940760_epub_apb_r1'
 import OEBPS9781454940760_EPUB_AFT_R1 from '@/components/OEBPS/9781454940760_epub_aft_r1'
 import OEBPS9781454940760_EPUB_GLS_R1 from '@/components/OEBPS/9781454940760_epub_gls_r1'
 import OEBPS9781454940760_EPUB_ACK_R1 from '@/components/OEBPS/9781454940760_epub_ack_r1'
 import OEBPS9781454940760_EPUB_BIB_R1 from '@/components/OEBPS/9781454940760_epub_bib_r1'
 import OEBPS9781454940760_EPUB_RES_R1 from '@/components/OEBPS/9781454940760_epub_res_r1'
 import OEBPS9781454940760_EPUB_CRE_R1 from '@/components/OEBPS/9781454940760_epub_cre_r1'
 import OEBPS9781454940760_EPUB_ATA_R1 from '@/components/OEBPS/9781454940760_epub_ata_r1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/9781454940760_epub_toc_r1",
 			"name" : "OEBPS/9781454940760_epub_toc_r1",
 			"component" : OEBPS9781454940760_EPUB_TOC_R1
 		},
 		{
 			"path" : "/OEBPS/9781454940760_epub_int_r1",
 			"name" : "OEBPS/9781454940760_epub_int_r1",
 			"component" : OEBPS9781454940760_EPUB_INT_R1
 		},
 		{
 			"path" : "/OEBPS/9781454940760_epub_ch1_r1",
 			"name" : "OEBPS/9781454940760_epub_ch1_r1",
 			"component" : OEBPS9781454940760_EPUB_CH1_R1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js